import { Log, LogLevel } from "@statsig/client-core";

// Ignore Warn logs when Statsig is not available
const analyticsTool = import.meta.env.VITE_ANALYTICS_TOOL;
const statsigClientKey = import.meta.env.VITE_STATSIG_CLIENT_KEY;
const isStatsigAvailable = analyticsTool === "statsig" && statsigClientKey;

if (!isStatsigAvailable) {
  Log.level = LogLevel.Error;
}
